import React from 'react';
import type { FeedbackType } from '../../types/messages';
import { updateProposalBundleFeedback } from '../../api/proposalBundles';
import FeedbackButtons from '../feedback/FeedbackButtons';

type Props = {
  bundleId: number;
  tripId: number;
  currentFeedback: FeedbackType | null;
  commentSubmitted: boolean;
  onFeedbackUpdate: (bundleId: number, feedback: FeedbackType, commentSubmitted: boolean) => void;
};

const PROMPT_TEXTS: Record<FeedbackType, string> = {
  good: 'よろしければ、提案の改善のために、よかった点をお聞かせください',
  bad: 'よろしければ、提案の改善のために、どのような提案が望ましかったかをお聞かせください'
};

const ProposalBundleFeedback = ({
  bundleId,
  tripId,
  currentFeedback,
  commentSubmitted,
  onFeedbackUpdate
}: Props) => {
  const handleSubmit = async (feedbackType: FeedbackType, comment?: string) => {
    const result = await updateProposalBundleFeedback(String(tripId), bundleId, feedbackType, comment);
    onFeedbackUpdate(bundleId, feedbackType, result.feedbackCommentSubmitted);
  };

  return (
    <FeedbackButtons
      currentFeedback={currentFeedback}
      commentSubmitted={commentSubmitted}
      promptTexts={PROMPT_TEXTS}
      onSubmit={handleSubmit}
      popupAlign="right"
    />
  );
};

export default ProposalBundleFeedback;
